// extracted by mini-css-extract-plugin
export default {"card":"Card_card__iaGLF","img":"Card_img__vxQUn","film_name":"Card_film_name__2ERbr","rate":"Card_rate__irg7H"};